// components
import Button from '@mui/material/Button';

// hooks
import { useTranslation } from 'react-i18next';

// styles
import {
  BenefitChangeLine,
  BenefitChangeNoticeBox
} from './RegisterAbsenceDialog.styles';

// utils
import { formatByLocale } from 'utils/date';

// types
import type { BenefitChangeNoticeProps } from './BenefitChangeNotice.types';

/**
 * An inschaling that changes inside the period, said where the period is
 * chosen: the planner may want the absence to stop where the inschaling does.
 * One line per work agreement; only an inschaling that ends inside the period
 * offers the jump, one that only starts there has no end to run up to.
 */
const BenefitChangeNotice = ({
  changes,
  onEndAtBenefitEnd
}: BenefitChangeNoticeProps) => {
  'use memo';
  const { t } = useTranslation('common');

  if (!changes.length) {
    return null;
  }

  return (
    <BenefitChangeNoticeBox data-testid="benefit-change-notice">
      {changes.map((change) => (
        <BenefitChangeLine key={change.waId}>
          <span>
            {change.kind === 'ends' && change.lastDay
              ? // whether another inschaling follows is not in the data, so
                // the line names the end without promising a successor
                t('reactRegisterAbsence.benefitChangeEndsNotice', {
                  nr: change.nr ?? '',
                  date: formatByLocale(change.lastDay, 'd MMMM')
                })
              : t('reactRegisterAbsence.benefitChangeNotice', {
                  nr: change.nr ?? '',
                  date: formatByLocale(change.date, 'd MMMM')
                })}
          </span>
          {change.kind === 'ends' && change.lastDay && (
            <Button
              size="small"
              variant="text"
              color="info"
              onClick={() => onEndAtBenefitEnd(change.waId)}
            >
              {t('reactRegisterAbsence.benefitChangeUntilEnd', {
                date: formatByLocale(change.lastDay, 'd MMM')
              })}
            </Button>
          )}
        </BenefitChangeLine>
      ))}
    </BenefitChangeNoticeBox>
  );
};

export default BenefitChangeNotice;
